"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AccountLevelOrderAddItem = _interopRequireDefault(require("./AccountLevelOrderAddItem"));
var _AccountLevelOrderDelItem = _interopRequireDefault(require("./AccountLevelOrderDelItem"));
var _AtomLink = _interopRequireDefault(require("./AtomLink"));
var _CustomerLevelOrderAddItem = _interopRequireDefault(require("./CustomerLevelOrderAddItem"));
var _CustomerLevelOrderDelItem = _interopRequireDefault(require("./CustomerLevelOrderDelItem"));
var _PaymentAuthorization = _interopRequireDefault(require("./PaymentAuthorization"));
var _RefundAuthorization = _interopRequireDefault(require("./RefundAuthorization"));
var _ServiceLevelOrderAddItem = _interopRequireDefault(require("./ServiceLevelOrderAddItem"));
var _ServiceLevelOrderDelItem = _interopRequireDefault(require("./ServiceLevelOrderDelItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Order model module.
 * @module model/Order
 * @version 3.0
 */
var Order = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Order</code>.
   * @alias module:model/Order
   */
  function Order() {
    _classCallCheck(this, Order);
    Order.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Order, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Order</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Order} obj Optional instance to populate.
     * @return {module:model/Order} The populated <code>Order</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Order();
        if (data.hasOwnProperty('orderId')) {
          obj['orderId'] = _ApiClient["default"].convertToType(data['orderId'], 'Number');
        }
        if (data.hasOwnProperty('orderRefId')) {
          obj['orderRefId'] = _ApiClient["default"].convertToType(data['orderRefId'], 'String');
        }
        if (data.hasOwnProperty('orderLegacyId')) {
          obj['orderLegacyId'] = _ApiClient["default"].convertToType(data['orderLegacyId'], 'String');
        }
        if (data.hasOwnProperty('basketRefId')) {
          obj['basketRefId'] = _ApiClient["default"].convertToType(data['basketRefId'], 'String');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }
        if (data.hasOwnProperty('statusCode')) {
          obj['statusCode'] = _ApiClient["default"].convertToType(data['statusCode'], 'String');
        }
        if (data.hasOwnProperty('creationDate')) {
          obj['creationDate'] = _ApiClient["default"].convertToType(data['creationDate'], 'Date');
        }
        if (data.hasOwnProperty('userId')) {
          obj['userId'] = _ApiClient["default"].convertToType(data['userId'], 'Number');
        }
        if (data.hasOwnProperty('customerId')) {
          obj['customerId'] = _ApiClient["default"].convertToType(data['customerId'], 'Number');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('subTotal')) {
          obj['subTotal'] = _ApiClient["default"].convertToType(data['subTotal'], 'Number');
        }
        if (data.hasOwnProperty('vat')) {
          obj['vat'] = _ApiClient["default"].convertToType(data['vat'], 'Number');
        }
        if (data.hasOwnProperty('total')) {
          obj['total'] = _ApiClient["default"].convertToType(data['total'], 'Number');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('unit')) {
          obj['unit'] = _ApiClient["default"].convertToType(data['unit'], 'String');
        }
        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient["default"].convertToType(data['message'], 'String');
        }
        if (data.hasOwnProperty('messageCode')) {
          obj['messageCode'] = _ApiClient["default"].convertToType(data['messageCode'], 'String');
        }
        if (data.hasOwnProperty('paymentFailed')) {
          obj['paymentFailed'] = _ApiClient["default"].convertToType(data['paymentFailed'], 'Boolean');
        }
        if (data.hasOwnProperty('paymentFailedReason')) {
          obj['paymentFailedReason'] = _ApiClient["default"].convertToType(data['paymentFailedReason'], 'String');
        }
        if (data.hasOwnProperty('channel')) {
          obj['channel'] = _ApiClient["default"].convertToType(data['channel'], 'String');
        }
        if (data.hasOwnProperty('paymentAuthorization')) {
          obj['paymentAuthorization'] = _PaymentAuthorization["default"].constructFromObject(data['paymentAuthorization']);
        }
        if (data.hasOwnProperty('refundAuthorization')) {
          obj['refundAuthorization'] = _RefundAuthorization["default"].constructFromObject(data['refundAuthorization']);
        }
        if (data.hasOwnProperty('customerAddItems')) {
          obj['customerAddItems'] = _ApiClient["default"].convertToType(data['customerAddItems'], [_CustomerLevelOrderAddItem["default"]]);
        }
        if (data.hasOwnProperty('accountAddItems')) {
          obj['accountAddItems'] = _ApiClient["default"].convertToType(data['accountAddItems'], [_AccountLevelOrderAddItem["default"]]);
        }
        if (data.hasOwnProperty('serviceAddItems')) {
          obj['serviceAddItems'] = _ApiClient["default"].convertToType(data['serviceAddItems'], [_ServiceLevelOrderAddItem["default"]]);
        }
        if (data.hasOwnProperty('customerDelItems')) {
          obj['customerDelItems'] = _ApiClient["default"].convertToType(data['customerDelItems'], [_CustomerLevelOrderDelItem["default"]]);
        }
        if (data.hasOwnProperty('accountDelItems')) {
          obj['accountDelItems'] = _ApiClient["default"].convertToType(data['accountDelItems'], [_AccountLevelOrderDelItem["default"]]);
        }
        if (data.hasOwnProperty('serviceDelItems')) {
          obj['serviceDelItems'] = _ApiClient["default"].convertToType(data['serviceDelItems'], [_ServiceLevelOrderDelItem["default"]]);
        }
        if (data.hasOwnProperty('_links')) {
          obj['_links'] = _ApiClient["default"].convertToType(data['_links'], [_AtomLink["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Order</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Order</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['orderRefId'] && !(typeof data['orderRefId'] === 'string' || data['orderRefId'] instanceof String)) {
        throw new Error("Expected the field `orderRefId` to be a primitive type in the JSON string but got " + data['orderRefId']);
      }
      // ensure the json data is a string
      if (data['orderLegacyId'] && !(typeof data['orderLegacyId'] === 'string' || data['orderLegacyId'] instanceof String)) {
        throw new Error("Expected the field `orderLegacyId` to be a primitive type in the JSON string but got " + data['orderLegacyId']);
      }
      // ensure the json data is a string
      if (data['basketRefId'] && !(typeof data['basketRefId'] === 'string' || data['basketRefId'] instanceof String)) {
        throw new Error("Expected the field `basketRefId` to be a primitive type in the JSON string but got " + data['basketRefId']);
      }
      // ensure the json data is a string
      if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
        throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
      }
      // ensure the json data is a string
      if (data['statusCode'] && !(typeof data['statusCode'] === 'string' || data['statusCode'] instanceof String)) {
        throw new Error("Expected the field `statusCode` to be a primitive type in the JSON string but got " + data['statusCode']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['unit'] && !(typeof data['unit'] === 'string' || data['unit'] instanceof String)) {
        throw new Error("Expected the field `unit` to be a primitive type in the JSON string but got " + data['unit']);
      }
      // ensure the json data is a string
      if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
        throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
      }
      // ensure the json data is a string
      if (data['messageCode'] && !(typeof data['messageCode'] === 'string' || data['messageCode'] instanceof String)) {
        throw new Error("Expected the field `messageCode` to be a primitive type in the JSON string but got " + data['messageCode']);
      }
      // ensure the json data is a string
      if (data['paymentFailedReason'] && !(typeof data['paymentFailedReason'] === 'string' || data['paymentFailedReason'] instanceof String)) {
        throw new Error("Expected the field `paymentFailedReason` to be a primitive type in the JSON string but got " + data['paymentFailedReason']);
      }
      // ensure the json data is a string
      if (data['channel'] && !(typeof data['channel'] === 'string' || data['channel'] instanceof String)) {
        throw new Error("Expected the field `channel` to be a primitive type in the JSON string but got " + data['channel']);
      }
      // validate the optional field `paymentAuthorization`
      if (data['paymentAuthorization']) {
        // data not null
        _PaymentAuthorization["default"].validateJSON(data['paymentAuthorization']);
      }
      // validate the optional field `refundAuthorization`
      if (data['refundAuthorization']) {
        // data not null
        _RefundAuthorization["default"].validateJSON(data['refundAuthorization']);
      }
      if (data['customerAddItems']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['customerAddItems'])) {
          throw new Error("Expected the field `customerAddItems` to be an array in the JSON data but got " + data['customerAddItems']);
        }
        // validate the optional field `customerAddItems` (array)
        var _iterator = _createForOfIteratorHelper(data['customerAddItems']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _CustomerLevelOrderAddItem["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      if (data['accountAddItems']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['accountAddItems'])) {
          throw new Error("Expected the field `accountAddItems` to be an array in the JSON data but got " + data['accountAddItems']);
        }
        // validate the optional field `accountAddItems` (array)
        var _iterator2 = _createForOfIteratorHelper(data['accountAddItems']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _AccountLevelOrderAddItem["default"].validateJSON(_item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      if (data['serviceAddItems']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['serviceAddItems'])) {
          throw new Error("Expected the field `serviceAddItems` to be an array in the JSON data but got " + data['serviceAddItems']);
        }
        // validate the optional field `serviceAddItems` (array)
        var _iterator3 = _createForOfIteratorHelper(data['serviceAddItems']),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item2 = _step3.value;
            _ServiceLevelOrderAddItem["default"].validateJSON(_item2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        ;
      }
      if (data['customerDelItems']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['customerDelItems'])) {
          throw new Error("Expected the field `customerDelItems` to be an array in the JSON data but got " + data['customerDelItems']);
        }
        // validate the optional field `customerDelItems` (array)
        var _iterator4 = _createForOfIteratorHelper(data['customerDelItems']),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _item3 = _step4.value;
            _CustomerLevelOrderDelItem["default"].validateJSON(_item3);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        ;
      }
      if (data['accountDelItems']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['accountDelItems'])) {
          throw new Error("Expected the field `accountDelItems` to be an array in the JSON data but got " + data['accountDelItems']);
        }
        // validate the optional field `accountDelItems` (array)
        var _iterator5 = _createForOfIteratorHelper(data['accountDelItems']),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _item4 = _step5.value;
            _AccountLevelOrderDelItem["default"].validateJSON(_item4);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        ;
      }
      if (data['serviceDelItems']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['serviceDelItems'])) {
          throw new Error("Expected the field `serviceDelItems` to be an array in the JSON data but got " + data['serviceDelItems']);
        }
        // validate the optional field `serviceDelItems` (array)
        var _iterator6 = _createForOfIteratorHelper(data['serviceDelItems']),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _item5 = _step6.value;
            _ServiceLevelOrderDelItem["default"].validateJSON(_item5);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        ;
      }
      if (data['_links']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['_links'])) {
          throw new Error("Expected the field `_links` to be an array in the JSON data but got " + data['_links']);
        }
        // validate the optional field `_links` (array)
        var _iterator7 = _createForOfIteratorHelper(data['_links']),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _item6 = _step7.value;
            _AtomLink["default"].validateJSON(_item6);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} orderId
 */
Order.prototype['orderId'] = undefined;

/**
 * @member {String} orderRefId
 */
Order.prototype['orderRefId'] = undefined;

/**
 * @member {String} orderLegacyId
 */
Order.prototype['orderLegacyId'] = undefined;

/**
 * @member {String} basketRefId
 */
Order.prototype['basketRefId'] = undefined;

/**
 * @member {String} status
 */
Order.prototype['status'] = undefined;

/**
 * @member {String} statusCode
 */
Order.prototype['statusCode'] = undefined;

/**
 * @member {Date} creationDate
 */
Order.prototype['creationDate'] = undefined;

/**
 * @member {Number} userId
 */
Order.prototype['userId'] = undefined;

/**
 * @member {Number} customerId
 */
Order.prototype['customerId'] = undefined;

/**
 * @member {String} category
 */
Order.prototype['category'] = undefined;

/**
 * @member {Number} subTotal
 */
Order.prototype['subTotal'] = undefined;

/**
 * @member {Number} vat
 */
Order.prototype['vat'] = undefined;

/**
 * @member {Number} total
 */
Order.prototype['total'] = undefined;

/**
 * @member {String} currency
 */
Order.prototype['currency'] = undefined;

/**
 * @member {String} unit
 */
Order.prototype['unit'] = undefined;

/**
 * @member {String} message
 */
Order.prototype['message'] = undefined;

/**
 * @member {String} messageCode
 */
Order.prototype['messageCode'] = undefined;

/**
 * @member {Boolean} paymentFailed
 */
Order.prototype['paymentFailed'] = undefined;

/**
 * @member {String} paymentFailedReason
 */
Order.prototype['paymentFailedReason'] = undefined;

/**
 * @member {String} channel
 */
Order.prototype['channel'] = undefined;

/**
 * @member {module:model/PaymentAuthorization} paymentAuthorization
 */
Order.prototype['paymentAuthorization'] = undefined;

/**
 * @member {module:model/RefundAuthorization} refundAuthorization
 */
Order.prototype['refundAuthorization'] = undefined;

/**
 * @member {Array.<module:model/CustomerLevelOrderAddItem>} customerAddItems
 */
Order.prototype['customerAddItems'] = undefined;

/**
 * @member {Array.<module:model/AccountLevelOrderAddItem>} accountAddItems
 */
Order.prototype['accountAddItems'] = undefined;

/**
 * @member {Array.<module:model/ServiceLevelOrderAddItem>} serviceAddItems
 */
Order.prototype['serviceAddItems'] = undefined;

/**
 * @member {Array.<module:model/CustomerLevelOrderDelItem>} customerDelItems
 */
Order.prototype['customerDelItems'] = undefined;

/**
 * @member {Array.<module:model/AccountLevelOrderDelItem>} accountDelItems
 */
Order.prototype['accountDelItems'] = undefined;

/**
 * @member {Array.<module:model/ServiceLevelOrderDelItem>} serviceDelItems
 */
Order.prototype['serviceDelItems'] = undefined;

/**
 * @member {Array.<module:model/AtomLink>} _links
 */
Order.prototype['_links'] = undefined;
var _default = exports["default"] = Order;